/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One shape for both modes. Row keys are the requested dimension names plus each measure's alias; time_bucket is present only when grain is set, and time on ungrouped rows.
 */
export type AnalyticsQueryResult = {
  /**
   * The dataset queried
   */
  dataset: string;
  /**
   * A stable diagnostic identifier for how the query was answered. Deliberately not a table name.
   */
  plan: string;
  /**
   * Result rows
   */
  rows: Array<{ [k: string]: any }>;
};

/** @internal */
export const AnalyticsQueryResult$inboundSchema: z.ZodMiniType<
  AnalyticsQueryResult,
  unknown
> = z.object({
  dataset: z.string(),
  plan: z.string(),
  rows: z.array(z.record(z.string(), z.any())),
});

export function analyticsQueryResultFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsQueryResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsQueryResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsQueryResult' from JSON`,
  );
}
